import styled from 'styled-components';
import C from '@assets/themes/colors';
import { isCloseToWhite } from '@utils/colors'


interface ISquareProps {
    color: string;
    selected?: boolean;
}

interface IGeneratorBoxProps {
    drawBox: boolean;
}

export const Root = styled.div`
    padding: 15px 0px 15px 0px;
    &:focus {
        outline-width: 0;
        outline: none;
    }
`;

export const OEMColorsContainer = styled.div`
    padding-top: 10px;
`;

export const OEMColorContainer = styled.div`
`;

export const CommonColorContainer = styled.div`
`;

export const Title = styled.div`
    font-family: Roboto;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
    padding: 8px 0px 8px 15px;
`;

export const SquaresContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 8px 7px 8px 11px;
`;

export const Square = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 5px;
    background-color: ${(props: ISquareProps) => props.color };
    border: ${(props: ISquareProps) =>  props.selected ? "solid 2px #49d8de" : isCloseToWhite(props.color) ? "solid 2px #ebebee" : "solid 2px transparent" };
    margin: 4px;
    cursor: pointer;
`;

export const AddColor = styled.div`
    width: 38px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

export const ColorGeneratorContainer = styled.div`
    padding: ${(props: IGeneratorBoxProps) => props.drawBox ? "0px 45px 15px 15px" : "0px 15px"};
`;

export const ColorGeneratorBox = styled.div`
    width: 100%;
    border-radius: 5px;
    background-color: #FFFFFF;
    box-shadow: ${(props: IGeneratorBoxProps) => props.drawBox ? "4px 4px 20px 2px rgba(0, 0, 0, 0.1)" : ""};
    padding: ${(props: IGeneratorBoxProps) => props.drawBox ? "12px 12px 12px 12px" : "0px 0px 0px 0px"};
    margin: auto;
    margin-top: 8px;
    margin-bottom: 8px;
    display: block;
    text-align: center; 
`;

export const ColorGeneratorButton = styled.div`
    width: 145px;
    height: 36px;
    display: flex;
    align-items: center;
    background-color: #366cc8;
    cursor: pointer;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 5px;
    display: block;
    text-align: center; 
`;

export const ColorGeneratorButtonText = styled.span`
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #FFFFFF;
    width: 100%;
    height: 36px;
    line-height: 36px;
`;

export const AddOEMCheck = styled.input.attrs({ type: 'checkbox' })`
    width: 20px;
    height: 20px;
    border: 1px solid #aaaaaa;
    background:#ff0000;
    margin: 0px;
    padding: 0px;
`;

export const AddOEMText = styled.label`
    padding-left: 8px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
    cursor: pointer;
`;

export const AddOEMSection = styled.div`
    display: flex;
    align-items: center;
`;

export const GradientCheck = styled.input.attrs({ type: 'checkbox' })`
    height:20px;
    width:20px;    
    border: 1px solid #aaaaaa;
    background:#ff0000;
`;

export const GradientText = styled.label`
    width: 49px;
    height: 15px;
    flex-grow: 0;
    margin: 0px 0px 0px 5px;
    font-family: Roboto;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
`;


export const GradientColorContainer = styled.div`
    display:flex;
    padding: 8px 0px 8px 15px;
    align-items: center;
`;

export const optionContainer = styled.div`
  display:flex;
  flex-direction:column;  
  align-items: center;
  margin-top:10px;
  width:100%;
`;

export const SliderContainer = styled.div`
  display:flex;  
  width:85%;  
`;


export const SliderTextContainer = styled.div`
  display:flex;  
  width:90%;  
  flex-direction:row;
  align-items:center;
`;


export const InputSlider = styled.input
`
  width: 40px;
  height: 18px;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  background-color: var(--white);
  text-align: center;
  margin:10px;
  outline: none;
`;


export const InputAngle = styled.input
`
  width: 40px;
  height: 18px;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  background-color: var(--white);
  text-align: center;
  margin:10px 3px 10px 10px;
  outline: none;
`;

export const Label = styled.div`
  display:flex;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  margin:6px 10px 10px 10px;
  width:200px;
`;

export const CircularContainer = styled.div`
  margin: 5px;
`;
